import { DriverAgeRange } from 'api/fleet/types'

export type GetHirePointsResponse = {
  hirePoints: {
    currentPage: number
    pageItems: HirePoint[]
    pageSize: number
    totalItems: number
    totalPages: number
  }
}

export type HirePoint = {
  id: number
  hirePointName: string
  country: string
  city: string
  locationName: string
  isClosed: boolean
  availableCarsCount: number
  availableEquipmentsCount: number
  hasEmptyFields?: boolean
}

export type HirePointData = {
  name?: string
  companyID?: number
  locationId?: string | null
  countryId?: string
  countryName?: string
  cityId?: string | null
  cityName?: string
  region?: string
  workingHours?: WorkingHours
  dropoffHours?: WorkingHours
  latitude?: string
  locationName?: string
  longitude?: string
  phone?: string
  apartment?: string
  building?: string
  street?: string
  stateName?: string
  stateId?: string
  postalCode?: string
  currencyID?: number | string
  isActive?: boolean
  waitingHours?: WaitingHours
  currencyName?: string
  hirePointName?: string
  phoneCountryCode?: string
  phoneAreaCode?: string
  email?: string
  minimumPeriodDay?: string
  maximumPeriodDay?: string
  pickupOption?: PickupOptions
  pickUpInstruction?: string
  dropOffInstruction?: string
  startReservationHour?: string
  driverAgeRange?: DriverAgeRange
  locationType?: string
  newLocation?: {
    locationName?: string
    locationType?: string
    pendingCityId?: number
    cityName?: string
    shortCode?: string
  }
  shortCode?: string
  pendingLocationId?: string
  pendingCityId?: string
}

export type ShortHirePointData = {
  id: number
  locationName: string
  country: string
  city: string
  street: string
  building: string
  currency: string
  pickUpOption: string
}

export enum PickupOptions {
  Default = 'No option selected',
  DeskInTerminal = 'Desk in terminal',
  ShuttleToLocation = 'Shuttle to location',
  MeetingInAirport = 'Meeting in airport',
}

export type GetHirePointListDataResponse = {
  hirePoints: ShortHirePointData[]
}

export type GetHirePointDataResponse = {
  hirePointInfo: HirePointData
}

type WaitingHours = {
  waitingHours?: string
  waitingHourPrice?: string
  waitingHourRange?: WaitingHourRange
  waitingHourFeeType?: WaitingHourFeeType
}

export enum WaitingHourFeeType {
  Fee = 'Fee',
  NoFee = 'No fee',
}

export enum WaitingHourRange {
  Both = 'Both',
  Pickup = 'Pick-up',
  Dropoff = 'Drop-off',
}

export type AvailableVehicleListResponse = {
  vehicles: {
    currentPage: number
    pageItems: Vehicle[]
    pageSize: number
    totalItems: number
    totalPages: number
  }
}

type Vehicle = {
  selected: boolean
  id: string
  name: string
  groupName: string
  sippCode: string
  image: string
}

export type AvailableEquipmentListResponse = {
  extras: {
    currentPage: number
    pageItems: Extra[]
    pageSize: number
    totalItems: number
    totalPages: number
  }
}

type Extra = {
  id: number
  name: string
  isAvailable: boolean
  selected: boolean
}

export type WorkingHour = {
  dayOfWeek: string
  dayStart: string
  dayStart2: string
  dayEnd2: string
  dayEnd: string
}

export type WorkingHours = Array<WorkingHour>

export type LocationsFilters = {
  hirePointsIds: number[]
  locations: string[]
  countries: string[]
}
